import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import {
  LEGAL_LAST_UPDATED,
  LEGAL_URLS,
} from '../../config/legal';
import './legal.css';

interface LegalPageShellProps {
  title: string;
  children: ReactNode;
  updatedAt?: string;
}

export function LegalPageShell({ title, children, updatedAt = LEGAL_LAST_UPDATED }: LegalPageShellProps) {
  return (
    <section className="section legal-page">
      <div className="container">
        <header className="legal-page__header">
          <h1>{title}</h1>
          <p className="legal-page__updated">Última actualización: {updatedAt}</p>
        </header>

        <article className="legal-page__content">{children}</article>

        <nav className="legal-page__nav" aria-label="Documentos legales">
          <Link to={LEGAL_URLS.privacy}>Política de privacidad</Link>
          <Link to={LEGAL_URLS.terms}>Condiciones del servicio</Link>
          <Link to={LEGAL_URLS.dataDeletion}>Eliminación de datos</Link>
          <Link to="/contacto">Contacto</Link>
        </nav>
      </div>
    </section>
  );
}
